import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../../../lesson/course-04/lesson-02/lesson";
import lesson0403 from "../../../lesson/course-04/lesson-03/lesson";
import lesson0406 from "../../../lesson/course-04/lesson-06/lesson";
import lesson0407 from "../../../lesson/course-04/lesson-07/lesson";
import lesson0409 from "../../../lesson/course-04/lesson-09/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "e2a4c7ab-8f85-4424-b677-0eacfd0c6307",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
  {
    id: "d078077d-2469-4c0d-bf32-6462b657149a",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0403),
    lesson: lesson0403,
  },
  {
    id: "f8cfa822-ac1a-4578-a281-3b96f49c7bd3",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0406),
    lesson: lesson0406,
  },
  {
    id: "3f5609eb-2a78-4f14-856d-1d41456a7553",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0407),
    lesson: lesson0407,
  },
  {
    id: "53c2b648-51ef-4bfd-9937-e4e6662da78f",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0409),
    lesson: lesson0409,
  },
];

export default lessonLinks;
